<script lang="ts">
  let {
    value,
  }: {
    value: unknown
  } = $props()

  const email = $derived(String(value ?? ''))
</script>

<a class="widget-email" href={`mailto:${email}`}>{email}</a>
